<template>
  <MarcoPrecios>
    <div slot="content">
      <div class="col1">
        <div v-if="step.numPresupuesto" class="numPresupuesto">
          <span>Ref: {{ step.numPresupuesto }}</span>
        </div>
        <div class="main-title">
          <h1 class="title">{{ step.pregunta }}</h1>
        </div>
      </div>

      <TuProducto :producto="producto" />

      <TusDatos :resumen="resumen" />

      <TuVehiculo :resumen="resumen" />
    </div>
    <a slot="botonAtras" href="#" @click.prevent="$router.go(-1)">Atrás</a>
    <a slot="botonSiguiente" href="#" @click.prevent="siguiente()">Guardar</a>
  </MarcoPrecios>
</template>

<script>
export default {
  store: ["step"],

  computed: {
    producto() {
      return this.step.resumen.producto;
    },

    resumen() {
      return this.step.resumen;
    }
  },

  mounted() {
    console.log(this.step.resumen);
  },

  methods: {
    siguiente: async function() {
      this.$emit("elegido", "");
    }
  }
};
</script>

<style lang="scss" scoped>
.numPresupuesto {
  font-size: 2rem;
  font-weight: 400;
  color: white;
  padding-right: 1rem;
  text-align: right;
  span {
    background-color: #999;
    border-radius: 0.5rem;
    padding: 0.2rem 0.6rem 0.2rem 0.6rem;
  }
}

dd {
  margin-left: 0.1rem;
}

.block-datos-resumen {
  margin-bottom: 2em;
  background-color: #f2f3f5;
}

.block-datos-resumen .title {
  margin-left: 0.2em;
  margin-bottom: 0.8em;
  font-size: 2.4rem;
  color: #16304f;
  font-weight: 300;
}

.block-datos-resumen .col-a {
  border-bottom: 2px solid #e5e7eb;
}

.block-datos-resumen .col-a,
.block-datos-resumen .col-b {
  padding-top: 2em;
  padding-bottom: 2em;
}

.block-datos-resumen .link a {
  font-size: 1.6rem;
  color: #0067aa;
}

.block-datos-resumen .link a:hover {
  text-decoration: none;
}

.contenido dt,
.contenido dd {
  float: left;
  margin-left: 0.2em;
  margin-bottom: 0.2em;
  font-size: 1.6rem;
}

.contenido dt {
  clear: left;
  margin-right: 0.2em;
}

.contenido dd {
  font-weight: 300;
}
/*Clearfix*/
.cl:before,
.cl:after {
  content: "";
  display: table;
}

.cl:after {
  clear: both;
}
</style>
